import { LanguageService } from './language/language.service';
import { ApiService } from './api/api.service';
import { GuidService } from './guid/guid.service';
import { NavigationService } from './navigation/navigation.service';
import { UserService } from './user/user.service';

export default {
  LanguageService: LanguageService,
  ApiService: ApiService,
  GuidService: GuidService,
  NavigationService: NavigationService,
  UserService: UserService,
};
